import script from "./searchInputSyosi.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchInputSyosi.vue?vue&type=script&setup=true&lang=ts"

import "./searchInputSyosi.vue?vue&type=style&index=0&id=7435d3c0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7435d3c0"]])

export default __exports__